module.exports = __webpack_public_path__ + "media/images/banner-marisol-3f673c94fa1dd8ca120d84fa04768578.jpg";